<script lang="ts">
	import { SlotSelect } from "@hitit/new_ui/src";
	import { t } from "@hitit/hub/src/stores";
	export let day = "";
	export let open = "";
	export let close = "";
	export let dayoff = false;

	const midnight = "23:59";
	const HHFormatValue = (h: number) => (h < 10 ? `0${h}` : `${h}`);
	const hourValue = (hhmm: string) => (hhmm ? hhmm.split(":")[0] : "");
	const minutValue = (hhmm: string) => (hhmm ? hhmm.split(":")[1] : "");
	const withMidnightTimeSplit = (hhmm: string, isHourReturn: boolean) => {
		let time = hhmm === midnight ? "24:00" : hhmm;

		return isHourReturn ? hourValue(time) : minutValue(time);
	};

	const drobBoxHourValues = (isClose: boolean) => {
		const values = [];

		for (let i = 0; i <= 23; i++) {
			values.push(HHFormatValue(i));
		}

		if (isClose) {
			values.push("24");
		}

		return values.map((v) => ({
			label: v,
			value: v,
			display: v,
		}));
	};

	const drobBoxMinuteValue = (close: string, isClose: boolean) => {
		const values = [];
		if (close === midnight && isClose) {
			values.push("00");
			return values.map((v) => ({
				label: v,
				value: v,
				display: v,
			}));
		}
		for (let i = 0; i <= 5; i++) {
			values.push(`${i}0`);
		}
		return values.map((v) => ({
			label: v,
			value: v,
			display: v,
		}));
	};

	function hourHandler(hour: string, isOpen: boolean) {
		const minute = withMidnightTimeSplit(isOpen ? open : close, false);

		const time = hour == "24" ? "23:59" : `${hour}:${minute || "00"}`;
		if ((isOpen && !close) || (!isOpen && !open)) {
			open = time === "23:59" ? "23:00" : time;
			close = time;
		} else if (isOpen) {
			open = time;
		} else if (!isOpen) {
			close = time;
		}
	}

	function minuteHandler(minute: string, isOpen: boolean) {
		const hour = withMidnightTimeSplit(isOpen ? open : close, true);
		const time = hour == "24" ? "23:59" : `${hour || "00"}:${minute}`;

		if ((isOpen && !close) || (!isOpen && !open)) {
			open = !isOpen && !open && time === midnight ? "00:00" : time;
			close = time;
		} else if (isOpen) {
			open = time;
		} else if (!isOpen) {
			close = time;
		}
	}

	function selectHandler(isOpen: boolean, hour: boolean) {
		return (e: Event) => {
			const target = e.target as HTMLSelectElement;
			const value = target.value;

			if (hour) {
				hourHandler(value, isOpen);
			} else {
				minuteHandler(value, isOpen);
			}
		};
	}

</script>

<div class="container">
	<span class="day" class:dayoff> {day} </span>
	<div class="open-close-wrapper">
		<div class="open time">
			<div class="hh select">
				<SlotSelect
					value={hourValue(open)}
					placeholder={'00'}
					backgroundColor={'#f0f0f4'}
					on:change={selectHandler(true, true)}
					let:displayValue
					let:noValue
					items={drobBoxHourValues(false)}>
					<span class="select-slot" class:placeholder={noValue}>
						{#if displayValue}{displayValue}{:else}00{/if}
					</span>
				</SlotSelect>
			</div>
			<span class="colon">:</span>
			<div class="mm select">
				<SlotSelect
					backgroundColor={'#f0f0f4'}
					value={minutValue(open)}
					placeholder={'00'}
					on:change={selectHandler(true, false)}
					let:displayValue
					let:noValue
					items={drobBoxMinuteValue(close, false)}>
					<span class="select-slot" class:placeholder={noValue}>
						{#if displayValue}{displayValue}{:else}00{/if}
					</span>
				</SlotSelect>
			</div>
		</div>
		<span class="hyphen">-</span>
		<div class="close time">
			<div class="hh select">
				<SlotSelect
					value={withMidnightTimeSplit(close, true)}
					backgroundColor={'#f0f0f4'}
					placeholder={'00'}
					on:change={selectHandler(false, true)}
					let:displayValue
					let:noValue
					items={drobBoxHourValues(true)}>
					<span class="select-slot" class:placeholder={noValue}>
						{#if displayValue}{displayValue}{:else}00{/if}
					</span>
				</SlotSelect>
			</div>
			<span class="colon">:</span>
			<div class="mm select">
				<SlotSelect
					backgroundColor={'#f0f0f4'}
					placeholder={'00'}
					on:change={selectHandler(false, false)}
					value={withMidnightTimeSplit(close, false)}
					let:displayValue
					let:noValue
					items={drobBoxMinuteValue(close, false)}>
					<span class="select-slot" class:placeholder={noValue}>
						{#if displayValue}{displayValue}{:else}00{/if}
					</span>
				</SlotSelect>
			</div>
		</div>
	</div>
	<div class="badge" class:dayoff on:click={() => (dayoff = !dayoff)}>
		{$t('hub.place.Off')}
	</div>
</div>

<style lang="scss">
	@import "../../../variables.scss";

	.container {
		display: flex;
		gap: 11px;
		align-items: center;

		.day {
			color: #46474b;
			@include appleAdjustTextForSize(16);
			&.dayoff {
				color: #e54848;
			}
		}

		.open-close-wrapper {
			align-items: center;
			display: flex;
			gap: 7px;
			flex-grow: 1;
		}

		.time {
			display: flex;
			gap: 4px;
			align-items: center;
			flex-grow: 1;

			.colon {
				font-weight: 500;
				font-size: 0.875rem;
			}

			.select {
				flex-grow: 1;
				height: 27px;
			}
		}

		.select-slot {
			display: flex;
			flex-grow: 1;
			justify-content: center;
			color: #6d6f76;
			padding-bottom: 2px;

			&.placeholder {
				color: #bcbfc3;
			}
		}

		.badge {
			box-sizing: border-box;
			width: 40px;
			height: 30px;
			border-radius: 15px;
			display: flex;
			align-items: center;
			justify-content: center;
			background-color: transparent;
			color: #f36464;
			border: solid 0.5px #f36464;
			padding-bottom: 2px;

			&:hover {
				cursor: pointer;
			}

			&.dayoff {
				background-color: #f36464;
				color: white;
			}
		}
	}

	@include DesktopSize {
		.container {
			font-size: 1.25rem;
			gap: 10px;
			.day {
				@include appleAdjustTextForSize(16, false);
			}
			.open-close-wrapper {
				gap: 10px;
			}

			.select-slot {
				font-size: 1.25rem;
				padding-bottom: 0px;
			}
			.time {
				.select {
					width: 40px;
				}
			}

			.badge {
				font-size: 1.25rem;
				width: 57px;
				padding-bottom: 2px;
			}
		}
	}

</style>
